import type { GameEvent, GameState } from './types';

/**
 * A copy of the state safe to send to `viewer` (a player index, or null for a
 * spectator):
 * - every face-down slot gets `card: null`, for every player including the viewer;
 * - the draw pile is emptied (its size stays in drawPileCount);
 * - with drawnCardVisibility 'private', a card drawn from the deck is hidden
 *   from everyone but the drawing player (in `drawn` and in `drewDeck` events);
 * - seed and rngState are zeroed.
 * Face-up cards, the discard pile, and cards taken from the discard pile are public.
 */
export function redactFor(s: GameState, viewer: number | null): GameState {
  const privateDraw = s.options.drawnCardVisibility === 'private';
  const hideDrawn = privateDraw && s.drawnFrom === 'deck' && viewer !== s.current;
  const log: GameEvent[] = s.log.map((e) =>
    privateDraw && e.type === 'drewDeck' && e.player !== viewer ? { ...e, card: null } : e,
  );
  return {
    ...s,
    seed: 0,
    rngState: 0,
    options: { ...s.options },
    players: s.players.map((p) => ({
      ...p,
      grid: p.grid.map((sl) => ({ card: sl.faceUp ? sl.card : null, faceUp: sl.faceUp })),
      holeScores: p.holeScores.slice(),
      playoffScores: p.playoffScores.slice(),
    })),
    active: s.active.slice(),
    drawPile: [],
    drawPileCount: s.drawPile.length > 0 ? s.drawPile.length : s.drawPileCount,
    discardPile: s.discardPile.slice(),
    drawn: hideDrawn ? null : s.drawn,
    turnsLeftInFinal: s.turnsLeftInFinal.slice(),
    playoffPlayers: s.playoffPlayers ? s.playoffPlayers.slice() : null,
    winners: s.winners ? s.winners.slice() : null,
    log,
  };
}
